import cx from 'classnames';
import * as React from 'react';

type OfferBoxProps = {
  title: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

export const OfferBox = (props: OfferBoxProps) => {
  return (
    <div
      className={cx(
        'flex flex-col border border-gray-300 bg-white relative',
        props.className
      )}
    >
      <h2 className="text-2xl tracking-wide md:text-3xl lg:text-4xl px-4 py-2 border-b border-gray-300 text-center">
        {props.title}
      </h2>
      <div className="pl-8 pr-3 py-4 flex-1 flex flex-col">
        {props.children}
      </div>
    </div>
  );
};
